module.exports = __webpack_public_path__ + "f5b136d976574f4128a8dfc195f155ac.woff";